let total_accounts = 0;
let temp = 100;
let total_assign_records = 0;
let total_assign_phone_records = 0;
let check = true;

function initAssignToGroupAnswerDropZone(drop_zone){
  const default_options = {
    drop: function(event,ui){
      //Check if it is an existing answer if so just insert it it into new placeholders
      // and re insert a placeholder in its original position. Also change its group to the data-group assign_to_group_answers_attributes
      // of the the new placeholder
      const answer = $(ui.draggable);

      if(answer.find("[name$='[sequence]']").length > 0){
        answer.find("[name$='[group]']").val("group_" + $(event.target).attr('data-group'));
        answer.siblings(".placeholder").css("display","block");
        initAssignToGroupAnswerDropZone(answer.siblings(".placeholder"));
        answer.draggable({axis: "x", revert: true, zIndex: 1000});
        $(event.target).css("display","none");
        answer.insertBefore($(event.target));
      } else {
        // If it is a new answer than assign values accordingly and insert into relevant placeholder
        const template = "assign_to_group_page[assign_to_group_answers_attributes][:index][:attribute]";
        const group = $(event.target).attr('data-group');
        const language_id = $($("[id^='assign-group-a-']:visible")[0]).attr("id").split("-")[3];
        const answer_row = $(event.target).parent().parent();
        answer.find(".delete-div").css("display","block");
        answer.find("#assign_to_group_destroy").attr("id","").attr("name",template.replace(":index",answer_row.attr('data-answer-index')).replace(":attribute","_destroy")).val("false");
        answer.find("#assign_to_group_name").attr("id","").attr("name",template.replace(":index",answer_row.attr('data-answer-index')).replace(":attribute","group")).val("group_" + group);
        answer.find("#assign_to_group_sequence").attr("id","").attr("name",template.replace(":index",answer_row.attr('data-answer-index')).replace(":attribute","sequence")).val(parseInt($(event.target).parent().parent().attr('data-answer-index')) + 1);
        answer.find("#assign_to_group_description").attr("id","").attr("name",template.replace(":index",answer_row.attr('data-answer-index')).replace(":attribute","answer"));
        answer.find(".instructions").remove();
        answer.draggable({axis: "x", revert: true, zIndex: 1000});
        $(event.target).css("display","none");
        answer.insertBefore($(event.target));
      }
    }
  };
  $(drop_zone).droppable(default_options);
}

$(document).ready(function () {
  influence_visual_feedback_and_mandatory_correct_for_interactive_page({ fieldNeutral: "#assign_to_group_page_neutral", fieldVisualFeedback: "#assign_to_group_page_visual_feedback", fieldMandatoryCorrect: "#assign_to_group_page_mandatory_correct" });

  setTimeout(function(){
    if($(".assign-to-group-answers-draggable-fields").find(".placeholder:visible").length > 0){
      initAssignToGroupAnswerDropZone(".placeholder:visible");
    }
  },0);

  if (!!!document.getElementById("assign_to_group_page_page_attributes_score")) {
    return;
  }

  $(".answer-container").draggable({axis: "x", revert: true, zIndex: 10000});

  $(".assign-to-group-answers-draggable-fields").find(".add-answer").click(function(e){
    e.preventDefault();
    if($("[data-answer-index]").length == 5){
      alert("Maximum of five answers allowed.");
      return;
    }
    const template = $(".assign-to-group-answers-draggable-fields #answer_template").clone();
    $(template).css("display","block");
    $(template).attr("id","");
    $(template).attr('data-answer-index',($("[data-answer-index]").length > 0)? $("[data-answer-index]").length : 0);
    initAssignToGroupAnswerDropZone($(template).find(".placeholder"));
    $(template).find(".answer-container").draggable({axis: "x", revert: true, zIndex: 1000});
    $(template).insertBefore($(this).parent().parent());
  });
});

window.remove_group_fields = function(link) {
  const current_placeholder = $(link).parent().parent().siblings(".placeholder");
  const current_answer_index = current_placeholder.parent().parent().attr('data-answer-index');
  const language_id = $($("[id^='assign-group-a-']:visible")[0]).attr("id").split("-")[3];
  const template = "assign_to_group_page[assign_to_group_answers_attributes][:index][:attribute]";
  $(link).parent().parent().parent().parent().remove();
  $("[data-answer-index]").filter(function(){
    return parseInt($(this).attr('data-answer-index')) > current_answer_index
  }).each(function(){
    $(this).attr('data-answer-index',parseInt($(this).attr('data-answer-index')) - 1);
    const index = $(this).attr('data-answer-index');
    const answer = $(this).find(".answer-container");
    answer.find("[name$='[_destroy]']").attr("name",template.replace(":index",index).replace(":attribute","_destroy"));
    answer.find("[name$='[group]']").attr("name",template.replace(":index",index).replace(":attribute","group"));
    answer.find("[name$='[sequence]']").attr("name",template.replace(":index",index).replace(":attribute","sequence")).val(parseInt(index) + 1);
    answer.find("[name$='[answer_multi["+language_id+"]]']").attr("name",template.replace(":index",index).replace(":attribute","answer"));
  });
}

window.add_group_fields = function(link, association, fields_to_clone, view, class_name) {
  total_assign_records = $('.assign-all-answers').length;
  if (total_assign_records < 5)
  {
    total_assign_records++;
  }
  else
  {
    alert("Can't add more than 5 answers");
    return;
  }
  if (view == 'new') {
    total_accounts++;
  }
  else {
    temp++;
    total_accounts = temp;
  }
  let regexp = new RegExp("new_" + association, "g");
  $('.' + class_name).append(fields_to_clone.replace(regexp, total_accounts));

  if ($('#assign_to_group_page_group_a').val())
    $('.group-1').text($('#assign_to_group_page_group_a').val());

  if ($('#assign_to_group_page_group_b').val())
    $('.group-2').text($('#assign_to_group_page_group_b').val());
}

$('#assign_to_group_page_mandatory_correct').on('click', function () {
  if ($('#assign_to_group_page_mandatory_correct').is(':checked'))
  {
    if (!$('#assign_to_group_page_feedback').is(':checked'))
    {
      $('#assign_to_group_page_feedback').click();
    }
    if ($('#assign_to_group_page_neutral').is(':checked'))
    {
      $('#assign_to_group_page_neutral').click();
    }
  }
});

$('#assign_to_group_page_neutral').on('click', function () {
  influence_visual_feedback_and_mandatory_correct_for_interactive_page({ fieldNeutral: "#assign_to_group_page_neutral", fieldVisualFeedback: "#assign_to_group_page_visual_feedback", fieldMandatoryCorrect: "#assign_to_group_page_mandatory_correct" });
});

$('#assign_to_group_page_feedback').on('click', function () {
  if (!$('#assign_to_group_page_feedback').is(':checked'))
  {
    if ($('#assign_to_group_page_mandatory_correct').is(':checked'))
    {
      $('#assign_to_group_page_mandatory_correct').click();
    }
  }
});
